import React from "react";
import { useRef } from "react";
import { Card, CardMedia, CardContent, CardActions, Typography, Button } from "@mui/material";
import {CardImg} from "reactstrap";
import { decompressToBase64, formatter } from "../../utils/common";
import "../Items/Item.css";
import Modal from "react-modal";
import ItemModal from "../Items/ItemModal.js";
import image from "../No_image_available.png";
import { AddToCart, GetCart, GetCount } from "../ShoppingCart/CartHandler.js";
import parse from "html-react-parser";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const apiUrl = process.env.REACT_APP_BASEURL;

function UserProducts(props) {
  const [activeItem, setActiveItem] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [startCard, setStartCard] = useState(0);
  const [endCard, setEndCard] = useState(5);
  const [userCards, setUserCards] = useState([]);
  const navigate = useNavigate();
  const [currUserData, userProData] = useState([]);
  const [itemQty, setItemQty] = useState(1);

  const addItem = (userItems) => {
    AddToCart(userItems.itemDescription, userItems.images, userItems.itemNumber, userItems.price, itemQty);
    props.setCartCount(GetCount());
  };


  useEffect(() => {
    getUserProducts();
  }, [props.userProVal]);

  useEffect(() => {
    userProData(userCards.slice(startCard, endCard));
  }, [userCards, startCard]);

  let onRequestClose = () => {
    setIsOpen(false);
    // setCartFunc(GetCart);
  };

  let handleClick = (item) => {
    setActiveItem(item);
    setIsOpen(true);
    props.setIsSwiper(false);
  };

  let handleMenuClick = (catName) => {
    let parentCategory = props.categories.find((category) =>
      category.children.some((child) => child.name === catName)
    );
    props.setCategory(parentCategory);
    navigate("/CategorySearchResults");
  };

  const buttonRightClick = () => {
    if (endCard + 5 > userCards.length) {
      setEndCard(userCards.length);
      setStartCard(userCards.length - 5);
    } else {
      setEndCard(endCard + 5);
      setStartCard(startCard + 5);
    }
  };

  const buttonLeftClick = () => {
    if (startCard - 5 < 0) {
      setStartCard(0);
      setEndCard(5);
    } else {
      setStartCard(startCard - 5);
      setEndCard(endCard - 5);
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const getUserProducts = async () => {
    if (props.userProVal === true) {

      await delay(2000); // Delay for 2 seconds
      axios.get(apiUrl + `/api/Items/GetCustomerWebItems`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token.token,
        },
      })
        .then((response) => {
          setUserCards(response.data); // Make sure response.data is an array
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const swiperRef = useRef(null);

  const renderPopCards = () => {
    if (userCards.length < 1) {
      return (
        <div role="status" class="space-y-2.5 animate-pulse md:h-[15em] w-screen">
        <div class="flex items-center w-full">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[70em]">
          <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[40em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[60em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <span class="sr-only">Loading...</span>
      </div>
      );
    } else {
      return (
        <div className={`md:max-w-6xl max-w-sm mx-auto py-8    ${props.isSwiper ? "block" : "hidden"}`}>
          <h2 className="text-2xl font-bold text-center mb-6">User Products</h2>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },  // Small screens: 1 card
              640: { slidesPerView: 2, spaceBetween: 15 },  // Medium screens: 2 cards
              1024: { slidesPerView: 4, spaceBetween: 50 }, // Large screens: 3 cards
            }}
            navigation={true}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: true }}
            loop={false}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="px-5 py-4 "
          >

            {!!userCards &&
              userCards.map((userItems) => (
                <SwiperSlide
                  onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                  onMouseLeave={() => swiperRef.current?.autoplay.start()}
                  key={userItems.itemNumber}>
                  <Card
                    className="w-64 sm:w-56 md:w-60 lg:w-64 h-[350px] rounded-lg overflow-hidden p-2 shadow-md 
                      transition-all duration-300 ease-in-out hover:shadow-[0px_5px_15px_rgba(0,0,0,0.37)] hover:scale-[1.02] 
                      group cursor-pointer flex flex-col justify-between"
                    onClick={() => handleClick(userItems)}
                  >
                    {/* Image Section */}
                    <div className="h-32 flex justify-center items-center bg-white">
                      <CardImg
                        top
                        className="card-picture"
                        src={
                          "data:image/png;base64," +
                          decompressToBase64(userItems.images[0]?.compressedImageData)
                        }
                        id={userItems.itemNumber + "Img"}
                        alt={userItems.itemNumber}
                      />
                    </div>

                    {/* Content Section */}
                    <CardContent className="flex flex-col flex-grow justify-between p-2">
                      <Typography variant="h6" className="font-semibold text-gray-800 text-sm md:text-base">
                        {userItems.itemNumber}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className="text-blue-500 cursor-pointer hover:underline text-xs md:text-sm"
                      >
                        {userItems.categoryName}
                      </Typography>
                      <Typography
                        variant="body2"
                        className="text-gray-600 mt-1 text-xs md:text-sm line-clamp-2 h-10"
                      >
                        {userItems.itemDescription}
                      </Typography>
                      {userItems.available !== null && (
                        <Typography variant="body2" className="text-green-600 font-medium text-xs md:text-sm">
                          {userItems.available}
                        </Typography>
                      )}
                    </CardContent>

                    {/* Price & Action Section */}
                    <CardActions className="p-2 flex justify-between items-center">
                      <Typography
                        variant="body1"
                        className="font-bold text-gray-900 text-sm md:text-base min-w-[50px] text-right"
                      >
                        {formatter.format(userItems.price)}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        className="rounded-full text-xs md:text-sm w-34 h-9 flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          addItem(userItems);
                        }}
                      >
                        Add to Cart
                      </Button>
                    </CardActions>
                  </Card>

                </SwiperSlide>
              ))}

          </Swiper>
          {isOpen ? (
            <ItemModal
              setIsSwiper={props.setIsSwiper}
              item={activeItem}
              onRequestClose={onRequestClose}
              cartCount={props.cartCount}
              setCartCount={props.setCartCount}
            />
          ) : null}
        </div>
      );
    }
  };
  return <div className=" w-screen  md:px-10 sm:py-0 py-10 md:py-10 lg:py-10" >{renderPopCards()}</div>;
}


export default UserProducts;
